export default __webpack_public_path__ + "static/media/logo-christian-dior-couture.a194d032.webp";